import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);

  const [sections, setSections] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllSections = async () => {
    const response = await getData("/common/masters/all-sections?without_meta=true");

    if (response?.success) {
      setSections(await Select2Data(response?.data, "section_id"));
    }
  };

  useEffect(() => {
    GetAllSections();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("section_id", data?.section_id?.value);
      DataToSend.append("hone_title", data?.hone_title);
      DataToSend.append("hone_sub_title", data?.hone_sub_title);
      const response = await postData(`/admin/seo/meta-section`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Meta Section
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Section</Form.Label>
                    <Controller
                      name="section_id" // name of the field
                      {...register("section_id", {
                        required: "Select Section",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.section_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={sections}
                        />
                      )}
                    />
                    {errors.section_id && (
                      <span className="text-danger">
                        {errors.section_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Title</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="hone_title"
                        placeholder="Title"
                        className={classNames("", {
                          "is-invalid": errors?.hone_title,
                        })}
                        {...register("hone_title", {
                          required: "Title is required",
                        })}
                      />
                    </InputGroup>
                    {errors.hone_title && (
                      <span className="text-danger">
                        {errors.hone_title.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Sub Title</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="hone_sub_title"
                        placeholder="Sub Title"
                        className={classNames("", {
                          "is-invalid": errors?.hone_sub_title,
                        })}
                        {...register("hone_sub_title", {
                          required: "Sub Title is required",
                        })}
                      />
                    </InputGroup>
                    {errors.hone_sub_title && (
                      <span className="text-danger">
                        {errors.hone_sub_title.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>



              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
